// extracted by mini-css-extract-plugin
module.exports = {"NavIcon":"EmployerHeader_NavIcon__3s2J6","header":"EmployerHeader_header__1jeke","navText":"EmployerHeader_navText__2DWQJ","navElement":"EmployerHeader_navElement__YeKfq"};